import { Component, OnInit, Inject } from '@angular/core';
import {  MatDialogRef,
          MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProvisionsService } from '../../service/entity-services/provisions.service';

import { AgGridModule } from 'ag-grid-angular';


import * as provisionsColumns from '../../shared/entity-columns/provisions-columns';

let _ = require('lodash');


@Component({
    selector: 'app-list-of-provisions',
    templateUrl: './list-of-provisions.component.html',
    styleUrls: ['./list-of-provisions.component.css'],
    standalone: true,
    imports: [
      AgGridModule
    ]
  })
export class ListOfProvisionsComponent implements OnInit {

  listOfProvisionsTitle = null;
  onlyApprovedProvisions = false;
  listOfProvisions = [];

  gridApi = null;

  defaultColDef = { resizable: true,
                    sortable: true,
                    filter: true};

  defaultUserViewCols = [
                          provisionsColumns.colName,
                          provisionsColumns.colDescription
                        ];

  constructor(private provisionsService: ProvisionsService,
              private dialogRef: MatDialogRef<ListOfProvisionsComponent>,
              @Inject(MAT_DIALOG_DATA) data) {

      // if (data.listOfProvisionsTitle != undefined) {
      //   this.listOfProvisionsTitle = data.listOfProvisionsTitle;
      // } else {
      //   this.listOfProvisionsTitle = 'Provisions List';
      // }

      // if (data.approvedProvisions) {
      //   this.onlyApprovedProvisions = true;
      // }
    }

  async ngOnInit() {

    // if (this.globalDataService.allProvisions.length === 0) {
    //   // this.listOfProvisions = await this.globalDataService.fetchAllProvisionsPromise();
      
    //   this.globalDataService.allProvisions = await this.provisionsService.getAllProvisions();
    //   this.listOfProvisions = this.globalDataService.allProvisions;

    //   // this.listOfProvisions = await this.provisionsService.getProvisionsByPagination(null);
    // } else {
    //   this.listOfProvisions = this.globalDataService.allProvisions;
    // }

    // if (this.onlyApprovedProvisions) {
    //   // console.log('filter for only approved provisions');
    //   this.listOfProvisions = _.filter(this.listOfProvisions,
    //           function(o) {
    //             return o.approvedProvision === true;
    //           })
    // }

    // // console.log('*** approved provisions: ', this.listOfProvisions);

    // await this.delay(2000);
    // if (this.gridApi != undefined) {
    //   this.gridApi.resetRowHeights();
    // }
  }




  onCellClicked(event: any) {
    console.log('Cell Clicked!');
    console.log('cell event.data --> ', event.data);

    this.dialogRef.close(event.data);
  }


}
